import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/Users/selectRow',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async selectByConnectedCompanyId()
    {
        try
        {
            const response = await axios.get('/Users/selectByConnectedCompanyId');

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async save(params)
    {
        try
        {
            let response;
            if (typeof params.id !== 'undefined' && params.id != '')
            {
                response = await axios.post('/Users/updateRow', params);
            }
            else
            {
                response = await axios.post('/Users/insertRow', params);
            }
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/Users/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
